import type { SessionDto } from '@pos/api-client';
import { useTranslation } from '@pos/i18n';
import type { ReactNode } from 'react';
import { EmptyState } from './components/EmptyState';
import { hasPermission } from './session';

/** Shows children only when the user has the permission; the server enforces it regardless. */
export function RequirePermission({
  session,
  permission,
  children,
}: {
  session: SessionDto;
  permission: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return hasPermission(session, permission) ? (
    children
  ) : (
    <section className="pos-admin-page">
      <EmptyState heading={t('admin.errors.forbiddenTitle')} description={t('admin.errors.forbidden')} />
    </section>
  );
}
